import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-686f5ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Agenda", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  placeholder: "Escribe aquí para filtrar.",
  class: "input-job"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "modern-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", null, "Hora"),
    /*#__PURE__*/_createElementVNode("th", null, "Evento"),
    /*#__PURE__*/_createElementVNode("th", null, "Ver más")
  ])
], -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import {onMounted,ref} from 'vue'
import AgendaService from '@/services/AgendaService'
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgendaView',
  setup(__props) {

const service = new AgendaService()
const quotes:any = ref([])
const loading = ref(false)

onMounted(async()=>{
    loading.value = true
    quotes.value = await service.GetQuote()
    loading.value = false
})




/*const handleSearch = () => {
    loading.value = true
    filteredEmploys.value = employs.value.filter(item => item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}*/

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("form", _hoisted_4, [
            _createVNode(_component_v_icon, { name: "fa-filter" }),
            _hoisted_5
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quotes.value, (elm) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: elm.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(elm.date.slice(0,10)), 1),
                    _createElementVNode("td", null, _toDisplayString(elm.date.slice(10,16)), 1),
                    _createElementVNode("td", null, _toDisplayString(elm.title), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'viewAgenda', params:{id : elm?.id} }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).THIRD_COLOR,
                            scale: "2"
                          }, null, 8, ["fill"])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})